module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7VXWX"))).then(() => parcelRequire('ikE14'));